/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import TextArea, { TextAreaProps } from './index';
import { CommonReactHookFormProps } from '../types';

interface RHFTextAreaProps<
  FormFields extends FieldValues,
> extends TextAreaProps, CommonReactHookFormProps<FormFields> { }

function RHFTextArea<FormFields extends FieldValues>(
  props: RHFTextAreaProps<FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    disabled,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: string) => {
    onChange(event);
  };

  return (
    <TextArea
      label={label}
      value={field.value}
      disabled={disabled}
      error={error}
      onChange={handleChange}
      {...rest}
    />
  );
}

export default RHFTextArea;
